import React from 'react';

import { useSelectedVariantContext } from '../../context/TreatmentSelectorContext';

interface Props {
    children: React.ReactNode;
}

const PriceCheckerWrapper = ({ children }: Props) => {
    const selectedVariant = useSelectedVariantContext();

    if (!selectedVariant?.type || selectedVariant.type !== 'ODONLY') {
        return children;
    }

    return (
        <div className="space-y-150 md:p-100 md:rounded-100 md:border md:border-decorators-subtle">
            {children}
        </div>
    );
};

export default PriceCheckerWrapper;
